<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">RIONet Formulare</h1>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card shadow">
                        <div class="card-header border-0 mb--4">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Formulare</h3>
                                </div>
                                <div class="col text-right">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-red"><i
                                        class="fad fa-hand-holding-box" aria-hidden="true"></i></div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <!--<p><strong>Hinweis:</strong> <br>Erläuterungen zu den RIO-Authentifizierungsmöglichkeiten
                                sowie deren Kosten finden Sie in der
                                <a target="_blank" rel="noopener"
                                   href="/docs/RIO-2Faktorzugriffe.pdf"
                                   class="pdf">Übersichtsmatrix</a>
                            </p>-->
                            <div class="bg-warning text-white p-3 rounded">
                                Der Benutzer muss bereits zur Eröffnung an Talus
                                gemeldet sein.
                            </div>
                            <collapse>
<!--                                <collapse-item name="1" id="1">
                                    <template v-slot:title>
                                        <h5 class="mb-0">Kurzanleitung
                                            SuisseID Signing Service</h5>
                                    </template>
                                    <div>
                                        <p>
                                            <a target="_blank" href="/docs/Kurzanleitung-SuisseID-Signing-Service.pdf">Kurzanleitung
                                                SuisseID Signing Service</a>
                                        </p>
                                    </div>
                                </collapse-item>-->
<!--                                <collapse-item name="2" id="2">
                                    <template v-slot:title>
                                        <h5 class="mb-0">Bestellung Talus-Zertifikat</h5>
                                    </template>
                                    <div>
                                        <p>
                                            <strong>Bestellung Talus-Zertifikat für persönliche Benutzer</strong>
                                            (Soft-Zertifikat der Talus Informatik AG)<br>Bestellung per Mail an
                                            <a href="mailto:servicedesk@talus.ch">servicedesk(at)talus.ch</a> mit Angabe
                                            Vor-/Nachname des entsprechenden Users (Zertifikat-Halter) sowie
                                            Zustell-Mailadresse für Versand des Soft-Zertifikates.</p>
                                    </div>
                                </collapse-item>-->
                               <collapse-item name="3" id="3">
                                    <template v-slot:title>
                                        <h5 class="mb-0">Bestellung nFactor Persönlicher Benutzer</h5>
                                    </template>
                                    <Form @submit="onSubmit" v-slot="{ handleReset }" :validation-schema="schema">
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="company"
                                                name="company"
                                                placeholder="Gemeinde/Firma *"
                                                rules="required"
                                                v-model="company"></base-input>
                                        </div>
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="suisseName"
                                                name="lastname"
                                                placeholder="Name Auftraggeber/Kontaktperson *"
                                                rules="required"
                                                v-model="lastname"></base-input>
                                        </div>
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="firstname"
                                                name="firstname"
                                                placeholder="Vorname Auftraggeber/Kontaktperson *"
                                                rules="required"
                                                v-model="firstname"></base-input>
                                        </div>
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="phone"
                                                name="phone"
                                                placeholder="Telefonnummer Auftraggeber/Kontaktperson (für Rückfragen) *"
                                                rules="required"
                                                v-model="phone"></base-input>
                                        </div>
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="mail"
                                                name="mail"
                                                placeholder="E-Mail-Adresse Auftraggeber/Kontaktperson (für Rückfragen) *"
                                                rules="required"
                                                v-model="mail"></base-input>
                                        </div>
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="userLastname"
                                                name="userLastname"
                                                placeholder="Name zum nFactor Benutzer *"
                                                rules="required"
                                                v-model="userLastname"></base-input>
                                        </div>
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="userFirstname"
                                                name="userFirstname"
                                                placeholder="Vorname zum nFactor Benutzer *"
                                                rules="required"
                                                v-model="userFirstname"></base-input>
                                        </div>
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="userPhone"
                                                name="userPhone"
                                                placeholder="Mobilenummer zum nFactor Benutzer *"
                                                rules="required"
                                                v-model="userPhone"></base-input>
                                        </div>
                                        <div class="row">
                                            <base-input
                                                class="w-100"
                                                id="userMail"
                                                name="userMail"
                                                placeholder="E-Mail-Adresse zum nFactor Benutzer"
                                                v-model="userMail"></base-input>
                                        </div>
                                        <div class="row">
                                            <h2>Gewünschter Aufschalttermin</h2>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="row col-lg-2">
                                                <base-input
                                                    class="w-100"
                                                    id="startDate"
                                                    name="startDate"
                                                    type="date"
                                                    v-model="startDate"></base-input>
                                            </div>
                                            <div class="col-auto">
                                                <base-checkbox
                                                    label="oder per sofort"
                                                    id="startDateCheck"
                                                    name="startDateCheck"
                                                    v-model="startDateCheck"
                                                    class="mb-3"
                                                >oder per sofort</base-checkbox>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <h2>Kosten</h2>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="row col-lg-12">Zugriff über MobileWeb mit nFactor
                                            </div>
                                            <div class="row col-lg-12">Preis pro User / pro Jahr (exkl. MwSt.): CHF 90.00
                                            </div>
                                        </div>
                                        <div class="row">
                                            <base-input type="textarea" id="content" name="content"
                                                        placeholder="Bemerkung"
                                                        class="w-100">
                                            </base-input>
                                        </div>
                                        <div class="row mt-4">
                                            <button class="btn btn-outline-primary" @click="handleReset">Löschen</button>
                                            <base-button type="primary" native-type="submit">Abschicken</base-button>
                                        </div>
                                    </Form>
                                </collapse-item>
                            </collapse>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {ref, computed, onMounted} from 'vue';
import {Form} from "vee-validate";
import * as yup from 'yup';
import Collapse from "../../../components/Collapse/Collapse";
import CollapseItem from "../../../components/Collapse/CollapseItem";
import BaseCheckbox from "../../../components/Inputs/BaseCheckbox.vue";
import UserService from '@/services/user.service';
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";


export default {
    name: "RIODokumente",
    components: {
        BaseCheckbox,
        Form,
        Collapse,
        CollapseItem
    },
    props: {
        type: {
            type: String,
            default: ""
        }
    },
    setup() {

        const company = ref('');
        const lastname = ref('');
        const firstname = ref('');
        const phone = ref('');
        const mail = ref('');
        const userLastname = ref('');
        const userFirstname = ref('');
        const userPhone = ref('');
        const userMail = ref('');
        const startDate = ref('');
        const startDateCheck = ref(false);
        const content = ref('');


        const clearForm = () => {
            company.value = '';
            lastname.value = '';
            firstname.value = '';
            phone.value = '';
            mail.value = '';
            userLastname.value = '';
            userFirstname.value = '';
            userPhone.value = '';
            userMail.value = '';
            startDate.value = '';
            startDateCheck.value = false;
            content.value = '';

        };

        const schema = yup.object({
            company: yup.string().required('Feld ist ein Pflichtfeld'),
            lastname: yup.string().required('Feld ist ein Pflichtfeld'),
            firstname: yup.string().required('Feld ist ein Pflichtfeld'),
            phone: yup.string().required('Feld ist ein Pflichtfeld'),
            mail: yup.string().required('Feld ist ein Pflichtfeld'),
            userLastname: yup.string().required('Feld ist ein Pflichtfeld'),
            userFirstname: yup.string().required('Feld ist ein Pflichtfeld'),
            userPhone: yup.string().required('Feld ist ein Pflichtfeld'),
            startDateCheck: yup.boolean(),
            startDate: yup.string().when('suisseDateCheck', {
                is: () => !startDateCheck.value,
                then: (schema) => schema.required('Eine von beiden Optionen muss gewählt werden'),
            }),
        });

        const onSubmit = (values) => {
            UserService.sendNFactor(values).then(
                success => {
                    swal.fire({
                        icon: 'success',
                        title: 'Daten erfolgreich verschickt',
                        showConfirmButton: false,
                        timer: 2000
                    });
                },
                error => {
                    swal.fire({
                        icon: 'warning',
                        title: 'Es ist ein Fehler aufgetreten',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    console.log(error);
                }
            );
        };

        return {
            content,
            company,
            lastname,
            firstname,
            phone,
            mail,
            userLastname,
            userFirstname,
            userPhone,
            userMail,
            startDate,
            startDateCheck,
            clearForm,
            onSubmit,
            schema,
        }

    }
}
</script>
